import FrameComponent2 from "../components/FrameComponent2";
import FrameComponent1 from "../components/FrameComponent1";
import "./PostSignInWelcomePage.css";

const PostSignInWelcomePage = () => {
  return (
    <div className="post-sign-in-welcome-page">
      <FrameComponent2 />
      <FrameComponent1 />
    </div>
  );
};

export default PostSignInWelcomePage;
